import styled from '@emotion/styled';

export const ErrorNotificationContainer = styled.div({
  border: '1px solid #D32F2F4D',
  borderRadius: '6px',
  background: '#FDF7F7',
  padding: '16px 16px 4px 16px',
  display: 'flex',
  flexDirection: 'column',
  width: '448px',
});
